module.exports = __webpack_public_path__ + "media/images/photos/green-018adade62904c0ef5a4fb6bb76bdd51.jpg";